<br />
<div class="container">
  <h2>Multiple Invoice Submission</h2>

  <!-- Informational Banner -->
  <div class="alert alert-primary d-flex align-items-center mb-4" role="alert">
    <i class="fas fa-info-circle me-3" style="font-size: 1.5rem"></i>
    <div>
      If you are a vendor working with the
      <strong
        >Sports & Exhibition Authority of Pittsburgh and Allegheny
        County</strong
      >, please visit their dedicated
      <a
        href="https://sportsandexhibitionauthority-vendor.aclarian.com/home"
        target="_blank"
        class="alert-link"
        >Vendor Portal</a
      >. This portal will continue to support vendors conducting business with
      the <strong>Stadium Authority of the City of Pittsburgh</strong>.
    </div>
  </div>

  <br />
  <div class="text-end">
    <button type="button" class="post-tag" (click)="openModal()">
      Add Invoice</button
    ><BR /><BR />
  </div>

  <div class="dashboard__review-table">
    <table class="table table-borderless">
      <thead>
        <tr>
          <th>PO Number</th>
          <th>Contact Name</th>
          <th>Contact Email</th>
          <th>Invoice Number</th>
          <th>Invoice Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let invoice of invoices; let i = index"
          [ngClass]="{
            'table-success': invoice.submissionStatus,
            'table-secondary': !invoice.submissionStatus,
          }"
        >
          <td>{{ invoice.PoNumber }}</td>
          <td>{{ invoice.ContactName }}</td>
          <td>{{ invoice.ContactEmail }}</td>
          <td>{{ invoice.InvoiceNumber }}</td>
          <td>{{ invoice.InvoiceDescription }}</td>
          <td>
            <div class="dashboard__review-action">
              <a href="#" title="Delete" (click)="removeInvoice(i)">
                <i class="skillgro-bin"></i>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    class="modal fade modal-lg"
    id="invoiceModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="invoiceModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="invoiceModalLabel">
            {{ isEditing ? "Edit" : "Add" }} Invoice
          </h5>
          <button
            type="button"
            class="btn-closed"
            (click)="closeInvoice()"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="invoiceForm">
            <div class="form-group">
              <div
                class="form-group"
                [ngClass]="{ 'has-error': !f['IsPo'].valid && submitted }"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  formControlName="IsPo"
                  (change)="onIsPoChanged()"
                />

                &nbsp;<label class="inline"
                  >Is there a Purchase Order associated with this
                  invoice?</label
                >
              </div>
            </div>
            <div class="form-group" *ngIf="invoiceForm.get('IsPo')?.value">
              <label class="inline"
                >PO Number <span class="required">*</span></label
              >
              <div
                class="form-group"
                [ngClass]="{ 'has-error': !f['PoNumber'].valid && submitted }"
              >
                <input
                  type="text"
                  class="form-control txt-area-height"
                  formControlName="PoNumber"
                  pattern="[0-9]*"
                  (input)="
                    utilityService.onlyNumbers($event, invoiceForm, 'PoNumber')
                  "
                />
              </div>
            </div>

            <div class="form-group">
              <label class="inline"
                >Contact Name <span class="required">*</span></label
              >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': !f['ContactName'].valid && submitted,
                }"
              >
                <input
                  type="text"
                  class="form-control txt-area-height"
                  formControlName="ContactName"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="inline"
                >Contact Email <span class="required">*</span></label
              >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': f['ContactEmail'].invalid && submitted,
                }"
              >
                <input
                  type="email"
                  class="form-control txt-area-height"
                  formControlName="ContactEmail"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="inline"
                >Invoice Date <span class="required">*</span></label
              >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': f['InvoiceDate'].invalid && submitted,
                }"
              >
                <input
                  type="date"
                  class="form-control txt-area-height"
                  formControlName="InvoiceDate"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="inline"
                >Invoice Number <span class="required">*</span></label
              >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': f['InvoiceNumber'].invalid && submitted,
                }"
              >
                <input
                  type="text"
                  class="form-control txt-area-height"
                  formControlName="InvoiceNumber"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="inline"
                >Invoice Amount <span class="required">*</span></label
              >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': f['OriginalPoAmount'].invalid && submitted,
                }"
              >
                <input
                  type="number"
                  class="form-control txt-area-height"
                  formControlName="OriginalPoAmount"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="inline"
                >Invoice Description <span class="required">*</span></label
              >
              <div
                class="form-group"
                [ngClass]="{
                  'has-error': f['InvoiceDescription'].invalid && submitted,
                }"
              >
                <textarea
                  rows="2"
                  class="form-control txt-area-height"
                  formControlName="InvoiceDescription"
                  maxlength="50"
                ></textarea>
                <div
                  class="char-counter"
                  [ngClass]="{
                    'text-danger': isInvoiceDescriptionLimitExceeded(),
                  }"
                >
                  <small
                    >{{ getInvoiceDescriptionCharCount() }}/50 characters</small
                  >
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="col-md-6">
                  <button
                    type="button"
                    class="post-tag"
                    (click)="fileInput.click()"
                  >
                    <i class="pe-7s-plus"></i> Add Attachment/s (up to 45MB)
                  </button>
                  <input
                    type="file"
                    #fileInput
                    [attr.accept]="utilityService.acceptedFileExtensions"
                    (change)="onFileSelected($event, fileInput)"
                    multiple
                    style="display: none"
                  />
                </div>
              </div>
            </div>

            <br />
            <div class="row" formArrayName="attachments">
              <div class="col-md-12">
                <div
                  *ngFor="let item of filesArray.controls; let i = index"
                  class="col-md-12 form-group file-display-container"
                >
                  <div
                    class="file-details d-flex justify-content-between align-items-center"
                  >
                    <span>{{ item.value.file?.name }}</span>
                    <button
                      type="button"
                      class="btn-remove"
                      (click)="removeFile(i)"
                    >
                      <i class="skillgro-bin"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="left-buttons">
            <button
              type="button"
              class="btn btn-primary modal-header-btn"
              [disabled]="!canSubmit"
              (click)="saveInvoice()"
            >
              Add Invoice</button
            >&nbsp;&nbsp;
            <button
              type="button"
              class="btn btn-reset modal-header-btn"
              (click)="resetInvoice()"
            >
              Reset</button
            >&nbsp;&nbsp;
          </div>
          <div class="right-buttons">
            <button
              type="button"
              class="btn btn-secondary modal-header-btn"
              (click)="closeInvoice()"
              data-dismiss="modal"
            >
              Close</button
            >&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-end">
    <BR /><button
      class="btn btn-success"
      [disabled]="!canSubmit"
      (click)="saveAllInvoices()"
    >
      Save All Invoices
    </button>
  </div>
</div>
